import { render, staticRenderFns } from "./ConcatSecgroup.vue?vue&type=template&id=0c8c300c&"
import script from "./ConcatSecgroup.vue?vue&type=script&lang=js&"
export * from "./ConcatSecgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports